import sessionClassifierBuilder from './sessionClassifierBuilder.js';
import withPitches from "./../sessionType/withPitches.js";
import sessionCouldHaveOldTaggingData from './../sessionContents/sessionCouldHaveOldTaggingData.js';
import sessionCouldHaveNewScoringData from './../sessionContents/sessionCouldHaveNewScoringData.js';
import supportedScoringType from './../scoringType/supportedScoringType.js';
import satisfiesAny from './../satisfiesAny.js';

const sessionSupported = sessionClassifierBuilder(
    withPitches,
    satisfiesAny(
        sessionCouldHaveOldTaggingData,
        sessionCouldHaveNewScoringData
    ),
    undefined,
    supportedScoringType
);

export default sessionSupported;